export default __webpack_public_path__ + "static/iggy-6269eae06963b2c470ac81424d358445.webp";